import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import _ from "lodash";
import { CollapseTable, ServiceThreadSpinner } from "./";
import { api } from "../utils";
import axios from "axios";

export default function InventoryDashBoardInventoryAdjustmentGrid(props) {
   const {
      selectedItem,
      typeOfDataSource
   } = props.params;

   const [alreadyDisplayed, setAlreadyDisplayed] = useState([]);
   const [data, setData] = useState([]);
   const [fiveDays, setFiveDays] = useState(-5);
   const [limitRowsLocal, setLimitRowsLocal] = useState(true);
   const [loaded, setLoaded] = useState(false);
   const [params, setParams] = useState({});
   const payload = {
      ItemNumber: selectedItem?.value,
      TypeOfSource: typeOfDataSource,
      Days: fiveDays,
      LimitRows: limitRowsLocal
   };

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      setLoaded(false);
      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params) //for the spinner
      }
      api.postS('Inventory/InventoryAdjustments', payload, source.token).then(response => {
         if (response.data.success) {
            const dataResponse = response.data.itemGrid.inventoryAdjustment;
            if (dataResponse.length) {
               setData(JSON.parse(dataResponse))
            }
         } else {
            throw new Error(response);
         }
      })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params, fiveDays, limitRowsLocal])

   const onChange = (docNum) => {
      let newList = _.cloneDeep(alreadyDisplayed);
      if (_.includes(newList, docNum)) {
         setAlreadyDisplayed(_.filter(newList, (x) => x !== docNum));
      } else {
         newList.push(docNum);
         setAlreadyDisplayed(newList);
      }
   };

   const onChangeRadioButtons = (type = "check", days) => {
      if (type === "radio") {
         setFiveDays(days);
      } else {
         setLimitRowsLocal(!limitRowsLocal);
      }
   };

   function Table({ data, alreadyDisplayed, onChange }) {
      const [displayed, setDisplayed] = useState([]);

      useEffect(() => {
         if (!_.isEqual(displayed, alreadyDisplayed)) {
            setDisplayed(alreadyDisplayed);
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [alreadyDisplayed])

      return (
         _.map(data, (d, index) => {
            return (
               <CollapseTable
                  collapse={_.includes(alreadyDisplayed, d.DocNum)}
                  row={d}
                  docNum={d.DocNum}
                  onChangeCallback={onChange}
                  key={index}
               />
            );
         })
      )
   }

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2" style={{ display: "inline" }}>Recent Inventory Adjustments</span>
                  <div className="float-end InLineAttributes">
                     <div>
                        <input
                           type="checkbox"
                           id="limitRows"
                           name="limitRows"
                           checked={limitRowsLocal}
                           onChange={() => onChangeRadioButtons()}
                           style={{ height: "8px", width: "8px" }}
                        /> <label>Limit 10 Rows?</label>
                     </div>
                     <div className="testingSpace"></div>
                     <div>
                        <input
                           type="radio"
                           id="5_days"
                           name="days"
                           defaultChecked={true}
                           onChange={() => onChangeRadioButtons("radio", -5)}
                        /> <label>5 Days</label>
                     </div>
                     <div className="testingSpace"></div>
                     <div>
                        <input
                           type="radio"
                           id="30_days"
                           name="days"
                           onChange={() => onChangeRadioButtons("radio", -30)}
                        /> <label>30 Days</label>
                     </div>
                  </div>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length ?
                     <>
                        <Row className="mb-1 px-2">
                           <Col className="custom-table-header-top-left"></Col>
                           <Col className="table-header">Mod</Col>
                           <Col className="table-header">Doc Type</Col>
                           <Col className="table-header">Date</Col>
                           <Col xs="2" className="table-header">Doc Num</Col>
                           <Col className="table-header">Loc</Col>
                           <Col className="table-header">UOFM</Col>
                           <Col className="table-header">Qty</Col>
                           <Col className="table-header">Cost</Col>
                           <Col className="table-header">Ext Cost</Col>
                           <Col className="custom-table-header-top-right">Cust/Vend</Col>
                        </Row>
                        <Table data={data} alreadyDisplayed={alreadyDisplayed} onChange={onChange} />
                     </>
                     :
                     <div>
                        <span>No inventory adjustments found for the period</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
